import { Injectable, signal } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {

  constructor() { }

  private TIMEZONE_MAP: Record<string, string> = {

    "US/Alaska": "America/Anchorage",
    "US/Arizona": "America/Phoenix",
    "US/Central": "America/Chicago",
    "US/Eastern": "America/New_York",
    "US/Hawaii": "Pacific/Honolulu",
    "US/Michigan": "America/Detroit",
    "US/Mountain": "America/Denver",
    "US/Pacific": "America/Los_Angeles",

    "America/Puerto_Rico": "America/Puerto_Rico",
    "America/Virgin": "America/St_Thomas",

    "Australia/Adelaide": "Australia/Adelaide",
    "Australia/Brisbane": "Australia/Brisbane",
    "Australia/Broken_Hill": "Australia/Broken_Hill",
    "Australia/Currie": "Australia/Currie",
    "Australia/Darwin": "Australia/Darwin",
    "Australia/Hobart": "Australia/Hobart",
    "Australia/Lord_Howe": "Australia/Lord_Howe",
    "Australia/Melbourne": "Australia/Melbourne",
    "Australia/Perth": "Australia/Perth",
    "Australia/Sydney": "Australia/Sydney",


    "Canada/Atlantic": "America/Halifax",
    "Canada/Central": "America/Winnipeg",
    "Canada/Eastern": "America/Toronto",
    "Canada/Mountain": "America/Edmonton",
    "Canada/Newfoundland": "America/St_Johns",
    "Canada/Pacific": "America/Vancouver",
    "Canada/Saskatchewan": "America/Regina"
  };


  formatDateWithTimezone(timezone: string, dateString: string): string {


    if (!dateString) {
      return 'Invalid Date';
    }
    try {

      const resolved = Intl.DateTimeFormat("en-US", { timeZone: timezone })
        .resolvedOptions().timeZone;

      const zone = resolved || this.TIMEZONE_MAP[timezone];
      const dt = DateTime.fromISO(dateString, { zone });

      if (!dt.isValid) {
        return 'Ivalid Date';
      }
      const formatted = dt.toFormat("LLL dd, yyyy h:mm a ZZZZ");
      return formatted;

    } catch (error) {
      console.error('Error formatting date with Luxon:', dateString, error);
      return 'Invalid Date';
    }
  }
}
